import "core-js/modules/es.array.push.js";
import { unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
import { computed, onMounted, onBeforeUnmount, watch, ref, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessageBox } from 'element-plus';
import { checkPendingHandover } from './utils/pendingHandoverAlert.mjs';
import SideNav from './components/SideNav.vue';
import { getAuthUser, isAuthValid } from './auth';
import { installChatViewport } from './utils/chatViewport';
const HANDOVER_DISMISS_KEY = 'handover_pending_alert_dismiss_until';
export default {
  __name: 'App',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const chatNavExpanded = ref(false);
    provide('chatNavigation', {
      expanded: chatNavExpanded,
      toggle: () => {
        chatNavExpanded.value = !chatNavExpanded.value;
      }
    });
    watch(() => route.path, () => {
      chatNavExpanded.value = false;
    });
    watch(() => route.path, path => {
      document.body.classList.toggle('chat-page-active', path === '/chat');
      document.documentElement.classList.toggle('chat-page-active', path === '/chat');
      if (path !== '/chat') document.body.classList.remove('chat-keyboard-open');
      window.dispatchEvent(new Event('chat-viewport-refresh'));
    }, {
      immediate: true
    });
    let stopChatViewport = null;
    onMounted(() => {
      stopChatViewport = installChatViewport();
    });
    onBeforeUnmount(() => {
      stopChatViewport?.();
      document.body.classList.remove('chat-page-active');
      document.documentElement.classList.remove('chat-page-active');
    });
    const isStandalonePage = computed(() =>
    // Lazy route loading must not start background authenticated requests before
    // the migration page has a chance to transfer an expired source session.
    window.location.pathname === '/launcher-migrate' || route.path === '/login' || route.meta?.loginPage === true || route.meta?.vipPublic === true || route.meta?.publicPage === true);
    let disposed = false;
    onBeforeUnmount(() => {
      disposed = true;
    });
    const encHeader = value => encodeURIComponent(String(value ?? '').trim());
    const authHeaders = () => {
      const user = getAuthUser();
      const headers = {};
      if (user?.role) headers['x-role'] = String(user.role);
      if (user?.store) headers['x-store'] = encHeader(user.store);
      if (user?.name) headers['x-user'] = encHeader(user.name);
      return headers;
    };
    const isHandoverDismissed = () => {
      const until = Number(localStorage.getItem(HANDOVER_DISMISS_KEY) || 0);
      return Number.isFinite(until) && Date.now() < until;
    };
    const dismissHandoverAlert = () => {
      localStorage.setItem(HANDOVER_DISMISS_KEY, String(Date.now() + 5 * 60 * 1000));
    };
    const checkPendingHandoverAlert = () => {
      const user = getAuthUser();
      if (!user?.name) return;
      if (user.role === 'chat_only') return;
      const key = JSON.stringify([user.name, user.role, user.store]);
      return checkPendingHandover({
        key,
        eligible: () => {
          const current = getAuthUser();
          return !disposed && !isStandalonePage.value && isAuthValid() && !isHandoverDismissed() && key === JSON.stringify([current?.name, current?.role, current?.store]);
        },
        load: async () => {
          const response = await fetch('/api/operations/handover/pending-alert', {
            headers: authHeaders()
          });
          if (!response.ok) return 0;
          return (await response.json())?.count;
        },
        show: count => ElMessageBox.confirm(`你有 ${count} 条上交款待确认，请及时处理。`, '上交款待确认', {
          confirmButtonText: '去确认',
          cancelButtonText: '稍后',
          type: 'warning',
          closeOnClickModal: false,
          distinguishCancelAndClose: true
        }),
        confirm: () => router.push({
          path: '/operations',
          query: {
            tab: 'handover'
          }
        }),
        dismiss: dismissHandoverAlert
      });
    };
    onMounted(() => {
      checkPendingHandoverAlert();
    });
    watch(() => route.fullPath, () => {
      checkPendingHandoverAlert();
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", {
        id: "app",
        class: _normalizeClass({
          'operations-mobile-layout': _unref(route).path === '/operations',
          'webpos-layout': _unref(route).path === '/web-pos',
          'chat-layout': _unref(route).path === '/chat',
          'chat-nav-expanded': _unref(route).path === '/chat' && chatNavExpanded.value
        })
      }, [!isStandalonePage.value ? _withDirectives((_openBlock(), _createBlock(SideNav, {
        key: 0,
        class: "app-side-nav"
      }, null, 512)), [[_vShow, _unref(route).path !== '/chat' || chatNavExpanded.value]]) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["main-content", {
          'main-content-login': isStandalonePage.value,
          'main-content-webpos': _unref(route).path === '/web-pos'
        }])
      }, [_createVNode(_component_router_view)], 2)], 2);
    };
  }
};